export class TuplaEditavel<T> {

  public objeto: T;
  public permiteEdicao: boolean;

  public constructor(objeto: T) {
    this.objeto = objeto;
    this.permiteEdicao = false;
  }
}